import React from "react";

import "./ChevronRight.scss";
import chevronRightImage from "../../assets/icons/chevron-right.svg";

const chevronRight = (props) => {
  return (
    <div className="chevron-right mx-1">
      <img src={chevronRightImage} alt="sep" className="img-fluid"></img>
    </div>
  );
};

export default chevronRight;
